<template>
  <div style="display: inline-block">
    <v-dialog v-model="isEditAssigned" persistent max-width="600">
      <v-card v-if="!loadingAgentGroup && !loadingAgentSubGroup">
        <v-layout>
          <v-flex class="pl-4 pt-3">
            <h3 class="title">{{ type == 'add' ? 'Add' : 'Edit' }} Ticket</h3>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn small fab flat :loading="loading || loadingTicket" @click="onCancelAssgined">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-card-text>
          <div v-if="selectedMenu == 'ticketInfo'">
            <v-layout wrap>
              <template v-if="$store.state.privilege && $store.state.privilege.assign_ticket">
                <v-flex
                  xs12
                  sm6
                  class="form-control px-1 pb-2"
                  :class="{ 'has-error': errors.has('group') }"
                >
                  <div class="caption mb-1 mt-2">Group *</div>
                  <v-autocomplete
                    v-model="ticket.group"
                    v-validate="'required'"
                    return-object
                    name="group"
                    :loading="loading"
                    :items="agentGroup"
                    outline
                    clearable
                    :item-text="'groupname'"
                    :item-value="'groupname'"
                    class="default-input"
                    single-line
                    :hide-details="!errors.has('group')"
                    :error="errors.has('group')"
                    :error-messages="errors.first('group')"
                    :placeholder="$t('Group')"
                    @change="onChangeGroup"
                  />
                </v-flex>
                <v-flex xs12 sm6 class="form-control px-1 pb-2">
                  <div class="caption mb-1 mt-2">Subgroup</div>
                  <v-autocomplete
                    v-model="ticket.subgroup"
                    return-object
                    name="subgroup"
                    :loading="loading"
                    :items="filterSubGroup"
                    outline
                    clearable
                    :item-text="'subgroupname'"
                    :item-value="'subgroupname'"
                    class="default-input"
                    single-line
                    :hide-details="!errors.has('subgroup')"
                    :error="errors.has('subgroup')"
                    :error-messages="errors.first('subgroup')"
                    :placeholder="$t('Sub Group')"
                    @change="onChangeSubGroup"
                  />
                </v-flex>
                <v-flex xs12 sm12 class="form-control px-1 pb-2">
                  <div class="caption mb-1 mt-2">Assigned to</div>
                  <v-autocomplete
                    v-model="ticket.assignedTo"
                    return-object
                    name="assignedTo"
                    :loading="loading"
                    :items="filterAgents"
                    outline
                    clearable
                    :item-text="'name'"
                    :item-value="'name'"
                    class="default-input"
                    single-line
                    :hide-details="!errors.has('assignedTo')"
                    :error="errors.has('assignedTo')"
                    :error-messages="errors.first('assignedTo')"
                    :placeholder="$t('Assigned To')"
                  />
                </v-flex>
              </template>
            </v-layout>

            <div class="text-xs-center">
              <v-btn
                outline
                color="grey"
                :loading="loading || loadingTicket"
                @click="onCancelAssgined"
              >
                {{ $t('cancel') }}
              </v-btn>
              <template v-if="$store.state.privilege && $store.state.privilege.update_ticket">
                <v-btn
                  color="primary"
                  depressed
                  :loading="loading || loadingTicket"
                  @click="onSave"
                  >{{ $t('Save') }}</v-btn
                >
              </template>
            </div>
          </div>
          <div v-else>
            <!-- Customize for Next Capital -->
            <NextCapitalAgentApprove :data="dataAgentApprove" @close="onCancelAssgined" />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ManageTicket from './ManageTicketLiveChat.js'
export default {
  mixins: [ManageTicket],

  mounted() {
    this.$validator.pause()
    this.$nextTick(() => {
      this.$validator.errors.clear()
      this.$validator.fields.items.forEach((field) => field.reset())
      this.$validator.fields.items.forEach((field) => this.errors.remove(field))
      this.$validator.resume()
    })
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/EditTicketLiveChat.vue